import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}auth`;

export const AuthLogin = (data) => axios.post(`${API_URL}/login`, data);

export const validateToken = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/profile-by-auth`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            // getContentType: 'application/json',  // Indicates the format of the request data
            // Accept: 'application/json',
        },
    });
}